<div class="author">
  <img src="../../assets/img/author.png" alt="">
  <div class="description">
    <h3>Artyom Vecherov</h3>
    <h4>CONTACT DETAILS</h4>
    <p>Cell-phone number: +375292851119</p>
    <p>E-mail: a.vecherov@gmail.com</p>
    <p>Skype: lingvostar</p>
    <p><i>Programming skills are in high demand around the globe. That’s why my goal is to do my best to ultimately become a full-stack programmer.
      “Never stop training! Unless you have a translation job as a freelance translator” is now my motto :)</i></p>
  </div>
</div>
